export default "__VITE_ASSET__Ci_xDQVI__"